import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { AdaptivePlannerScenarioApi } from '@/lib/api/adaptive-planner/scenario';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

export const getScenariosDatasetQueryOptions = ({
  planId,
  enabled = true,
}: {
  planId: number;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: adaptivePlannerQueryKeys.scenarios.dataset({
      planId,
    }),
    queryFn: () =>
      AdaptivePlannerScenarioApi.getScenariosDataSet({
        planId,
      }),
    enabled,
  });

export const useGetScenariosDatasetSuspenseQuery = ({
  planId,
  enabled = true,
}: {
  planId: number;
  enabled?: boolean;
}) => {
  return useSuspenseQuery(getScenariosDatasetQueryOptions({ planId, enabled }));
};
